// src/components/service-groups/ServiceColumns.js
import React from "react";
import { IconButton, Box, Typography } from "@mui/material";
import TableActionMenu from "../../../components/table-action-menu/table-action-menu";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";

export default function ServiceColumns(
  toggleExpand,
  expandedMap,
  handleDelete,
  openEdit
) {
  return [
    {
      dataKey: "id",
      name: "ID",
      align: "left",
      width: "100px",
    },
    {
      dataKey: "name",
      name: "Service Group / Role",
      align: "left",
      render: (_value, row) =>
        row.isParent ? (
          <Box display="flex" alignItems="center">
            <IconButton
              size="small"
              onClick={() => toggleExpand(row.id)}
              //   style={{ marginRight: 8 }}
            >
              {expandedMap[row.id] ? (
                <ExpandLessOutlinedIcon />
              ) : (
                <ExpandMoreOutlinedIcon />
              )}
            </IconButton>
            <Typography variant="body1">{row.name}</Typography>
          </Box>
        ) : (
          <Box pl={4}>
            <Typography variant="body1">{row.name}</Typography>
          </Box>
        ),
    },
    {
      dataKey: "rate",
      name: "Default Rate",
      align: "right",
      width: "100px",
      render: (value, row) =>
        row.isParent
          ? null
          : // format as currency, adjust to your needs:
            `$${Number(value || 0).toFixed(2)}`,
    },
    {
      dataKey: "revenueAccount",
      name: "Revenue Account",
      align: "left",
    },
    {
      dataKey: "actions",
      name: "",
      width: "40px",
      align: "center",
      render: (_value, row) =>
        row.isParent ? (
          <TableActionMenu
            noBorder
            options={[
              {
                title: "Edit",
                onClick: () => openEdit(row),
              },
              // uncomment if you want delete on parents only
              // {
              //   title: "Delete",
              //   onClick: () => handleDelete(row),
              // },
            ]}
          />
        ) : null,
    },
  ];
}
